// extracted by mini-css-extract-plugin
export var legendIndicator = "_8d-1";
export var legendRight = "_8d-0";